export function convertToDataURI(htmlContent: string): string {
  const encodedHTML = encodeURIComponent(htmlContent);
  const dataURI = `data:text/html;charset=utf-8,${encodedHTML}`;
  return dataURI;
}
